"use strict";

// ES3 safe
var _undefined = void 0;

module.exports = function (value) { return value !== _undefined && value !== null; };



//////////////////
// WEBPACK FOOTER
// ./~/type/value/is.js
// module id = 176
// module chunks = 9